import { useEffect } from 'react';
import {
    ENABLE_Veneer_Shield_QUESTION,
    getEnableClearDesignQuestionList,
    getEnableEcodontWireSelect,
} from '../../../../pages/DiffRetainer/utils';
import { IMPRESSION_TYPE } from '../../../../pages/hooks/DiffRetainerHooks/useRetainerRequestForm';
import useSetSelectDefaultValue from './useSetSelectDefaultValue';
/**
 * 为单牙弓保持器表单设置默认值，并处理 Veneer Shield 不预选隐藏选项的场景。
 */
const useSetSingleFormDefaultValue = (formMethods, formValues, impressionType) => {
    const selectedRetainer = formValues['archAndQuantity'];
    const isVeneerShieldRetainer = ENABLE_Veneer_Shield_QUESTION.includes(selectedRetainer);
    const upperClearDesignDefaultValue = isVeneerShieldRetainer
        ? undefined
        : impressionType === IMPRESSION_TYPE.UPPER
        ? 'NotCoverLingualOrPalatalWire'
        : undefined;
    const lowerClearDesignDefaultValue = isVeneerShieldRetainer
        ? undefined
        : impressionType === IMPRESSION_TYPE.LOWER
        ? 'NotCoverLingualOrPalatalWire'
        : undefined;

    useEffect(() => {
        if (!isVeneerShieldRetainer || formValues['fixedWire'] !== 'true') return;

        if (
            [IMPRESSION_TYPE.UPPER, IMPRESSION_TYPE.UPPER_AND_LOWER].includes(impressionType) &&
            formValues['clearRetainerDesignUpperOption'] === 'NotCoverLingualOrPalatalWire'
        ) {
            formMethods.setValue('clearRetainerDesignUpperOption', null);
        }

        if (
            [IMPRESSION_TYPE.LOWER, IMPRESSION_TYPE.UPPER_AND_LOWER].includes(impressionType) &&
            formValues['clearRetainerDesignLowerOption'] === 'NotCoverLingualOrPalatalWire'
        ) {
            formMethods.setValue('clearRetainerDesignLowerOption', null);
        }
    }, [formMethods, formValues, impressionType, isVeneerShieldRetainer]);

    // for single retainer type
    useSetSelectDefaultValue({
        parentField: 'archAndQuantity',
        childField: 'bleachingRetainersSelect',
        defaultValue: '4-4',
        triggerValue: 'bleachingRetainers',
        formMethods: formMethods,
        formValues: formValues,
    });
    useSetSelectDefaultValue({
        parentField: 'archAndQuantity',
        childField: 'LowTrimlineAreaSelect_1',
        defaultValue: '4-4',
        triggerValue: 'ecodontRetainerWithVeneerShield_1set',
        formMethods: formMethods,
        formValues: formValues,
    });
    useSetSelectDefaultValue({
        parentField: 'archAndQuantity',
        childField: 'LowTrimlineAreaSelect_3',
        defaultValue: '4-4',
        triggerValue: 'ecodontRetainerWithVeneerShield_3set',
        formMethods: formMethods,
        formValues: formValues,
    }); 
    useSetSelectDefaultValue({
        parentField: 'archAndQuantity',
        childField: 'palatalWireSelect',
        defaultValue: 'Round Twist Wire',
        triggerValue: 'fixedPalatalWire',
        formMethods: formMethods,
        formValues: formValues,
    });

    useSetSelectDefaultValue({
        parentField: 'archAndQuantity',
        childField: 'jigPlacementSelect',
        defaultValue: 'placement jig in middle of wire',
        triggerValue: 'fixedPalatalWire',
        formMethods: formMethods,
        formValues: formValues,
    });

    useSetSelectDefaultValue({
        parentField: 'archAndQuantity',
        childField: 'smartFitWireSelect',
        defaultValue: 'Round Twist Wire',
        triggerValue: 'MDLSmartFitRetainersWithWire',
        formMethods: formMethods,
        formValues: formValues,
    });

    useSetSelectDefaultValue({
        parentField: 'archAndQuantity',
        childField: 'ecodontWireSelect',
        // defaultValue : 'Round Twist Wire',
        defaultValue: 'Flat Twist Wire',
        triggerValue: getEnableEcodontWireSelect(),
        formMethods: formMethods,
        formValues: formValues,
    });

    useSetSelectDefaultValue({
        parentField: 'archAndQuantity',
        childField: 'ecodontRetainerWithWire_1setSelect',
        // defaultValue : 'Round Twist Wire',
        defaultValue: 'Flat Twist Wire',
        triggerValue: 'ecodontRetainerWithWire_1set',
        formMethods: formMethods,
        formValues: formValues,
    });

    // for clear retainer questions
    useSetSelectDefaultValue({
        parentField: 'archAndQuantity',
        childField: 'clearRetainerDesignUpperOption',
        // defaultValue : 'NotCoverLingualOrPalatalWire',
        defaultValue: upperClearDesignDefaultValue,
        // triggerValue : ENABLE_CLEAR_DESIGN_QUESTION,
        triggerValue: getEnableClearDesignQuestionList(formValues['fixedWire'], false),
        formMethods: formMethods,
        formValues: formValues,
    });

    useSetSelectDefaultValue({
        parentField: 'archAndQuantity',
        childField: 'clearRetainerDesignLowerOption',
        // defaultValue : 'NotCoverLingualOrPalatalWire',
        defaultValue: lowerClearDesignDefaultValue,
        // triggerValue : ENABLE_CLEAR_DESIGN_QUESTION,
        triggerValue: getEnableClearDesignQuestionList(formValues['fixedWire'], false),
        formMethods: formMethods,
        formValues: formValues,
    });

    // useSetSelectDefaultValue({
    //   parentField:'archAndQuantity',
    //   childField: 'clearRetainerDesignUpperOptionForSecondSet',
    //   defaultValue : impressionType === IMPRESSION_TYPE.UPPER ? 'NotCoverLingualOrPalatalWire' : undefined,
    //   triggerValue : getEnableClearDesignQuestionList(formValues['fixedWire'] , true),
    //   formMethods: formMethods,
    //   formValues : formValues,
    //   // exceptionalBool : formValues['archAndQuantity'] === 'ecodontRetainers' && formValues['clearRetainerDesignUpperOption'] === 'virtuallyRemoveLingualOrPalatalWire' && formValues['fixedWire'] === 'true'
    // })

    // useSetSelectDefaultValue({
    //   parentField:'archAndQuantity',
    //   childField: 'clearRetainerDesignLowerOptionForSecondSet',
    //   defaultValue : impressionType === IMPRESSION_TYPE.LOWER ? 'NotCoverLingualOrPalatalWire' : undefined,
    //   triggerValue : getEnableClearDesignQuestionList(formValues['fixedWire'] , true),
    //   formMethods: formMethods,
    //   formValues : formValues,
    //   // exceptionalBool : formValues['archAndQuantity'] === 'ecodontRetainers' && formValues['clearRetainerDesignLowerOption'] === 'virtuallyRemoveLingualOrPalatalWire' && formValues['fixedWire'] === 'true'
    // })

    // for pontic
    // useSetSelectDefaultValue({
    //   parentField : 'archAndQuantity',
    //   childField: 'pontic',
    //   defaultValue : 'insertAPontic',
    //   triggerValue : ENABLE_POTIC_RETAINER_TYPE,
    //   formMethods: formMethods,
    //   formValues : formValues
    // })

    // for ponticColor
    useSetSelectDefaultValue({
        parentField: 'pontic',
        childField: 'ponticColor',
        defaultValue: 'A2',
        // triggerValue : 'insertAPontic',
        triggerValue: 'colourPonticRequired',
        formMethods: formMethods,
        formValues: formValues,
    });
};

export default useSetSingleFormDefaultValue;
